export default __webpack_public_path__ + "static/media/large-crumb1-play.bd60c8a9.png";